// plop_marker:layouts_import
import MultiTemplatesTemplates from "./multi-templates-templates";
import SingleTemplateTemplates from "./single-template-templates";

export default {
  // plop_marker:layouts_add_layout
  MultiTemplatesTemplates,
  SingleTemplateTemplates
};
